import React, { ReactElement, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Stream, StreamState, AuthMode, ViewerStore } from "../../types";
import { reactToStream } from "../../actions";
import "./Toolbar.scss";
import {
  Button,
  Modal,
  ModalSize,
  Icon,
} from "@screencloud/screencloud-ui-components";
import StreamInfo from "../StreamInfo/StreamInfo";
import EmojiPicker from "../EmojiPicker/EmojiPicker";
import { RootState } from "../../reducers";

interface ToolbarProps {
  stream: Stream;
  streamState: StreamState;
  viewerCount: number;
}
const Toolbar = (props: ToolbarProps): ReactElement<ToolbarProps> => {
  const dispatch = useDispatch();
  const viewer: ViewerStore = useSelector((state: RootState) => state.viewer);

  const { stream, streamState, viewerCount } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <div className="toolbar desktop-only">
        <div className="stream-info">
          <span className="stream-name">{stream.name}</span>
          {streamState === StreamState.Live && (
            <span className="viewer-count">
              {viewerCount} viewer{viewerCount === 1 ? "" : "s"}
            </span>
          )}
        </div>
        <div className="stream-options">
          {streamState === StreamState.Live && (
            <EmojiPicker
              onEmojiPicked={async (e) => {
                dispatch(
                  reactToStream({
                    orgId: stream.screenCloudOrgId,
                    spaceId: stream.spaceId,
                    channelId: stream.channelId,
                    arn: stream.arn,
                    reactionData: {
                      userName:
                        viewer.user && viewer.token
                          ? viewer.user.name
                          : "Someone",
                      reaction: e.value,
                      profilePictureUrl:
                        viewer.token && viewer.user
                          ? viewer.user.profilePictureUrl
                          : null,
                    },
                  })
                );
              }}
            />
          )}
          {stream.authMode !== AuthMode.Public && (
            <div className="broadcast-settings">
              <Icon
                name="settings"
                className="broadcast-settings-icon"
                onClick={() => setIsModalOpen(true)}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        open={isModalOpen}
        title=""
        onClose={() => setIsModalOpen(false)}
        size={ModalSize.SMALL}
        className="stream-info-modal"
      >
        <div className="stream-info-modal-content">
          <div className="header">
            <div className="title">Broadcast Settings</div>
            <div className="subtitle">
              <span className="capitalize">
                {stream.authMode}
                {stream.authMode === AuthMode.Public ||
                stream.authMode === AuthMode.Private
                  ? ""
                  : " Protected"}
              </span>
            </div>
          </div>
          <StreamInfo stream={stream} backgroundColor="grey" />
          <div className="bottom-bar">
            <Button
              outline="true"
              onClick={() =>
                window.open(
                  process.env.REACT_APP_LIVE_STREAMS_HELP_LINK,
                  "_blank"
                )
              }
            >
              Help Setting Up
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Toolbar;
